import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import CoachingShoutOut from '../../../../components/coachingShoutOut/coachingShoutOUt';
import {
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
    // selectIsUseCoachingSkills,
} from '../../../../pages/login/authSlice';
import { changeDateFormate, datetimeToDate, getMonthName } from '../../../../utils/dateFormat';
import { getRole } from '../../../../utils/roleUtils';
import StrengthCommentCard from '../commentCardStrength/CommentCardStrength';
import Guidance from '../guidance/Guidance';
import '../strengths.scss';
import { StrengthList } from '../types';
import Header from './Header';
import { useDeleteCoachingMutation } from '../../coachingSlice';
import { DeleteCoachingDialog } from '../../../../components/deleteCoaching/DeleteCoachingDialog';

export type ReadStrengthsProps = {
    recieverId: string;
    receiverName: string;
    authorId: string;
    displayModal: boolean;
    month?: number;
    year?: number;
    OnViewState: (value: string) => void;
    OnEditStrength: (value: any) => void;
    OnDisplayModal: (value: boolean) => void;
    via?: number;
    coachingEntityId?: number;
};

const ReadStrengths = ({
    receiverName,
    recieverId,
    authorId,
    displayModal,
    year,
    month,
    OnViewState,
    OnEditStrength,
    OnDisplayModal,
    via,
    coachingEntityId,
}: Readonly<ReadStrengthsProps>) => {
    const [first, setFirst] = useState(0);
    const [commentView, setCommentView] = useState(false);
    const [strengthList, setStrengthList] = useState<any[]>([]);
    const [isResponse, setIsResponse] = useState<boolean>(false);
    const [isGuidanceVisible, setIsGuidanceVisible] = useState<boolean>(false);
    const [shoutoutVisible, setTodoShoutOutVisible] = useState(false);
    const userRole = getRole(
        useSelector(selectCurrentUserManagerLevel),
        useSelector(selectIsPseudoSupervisor)
    );
    const [DeleteCoaching] = useDeleteCoachingMutation();
    const [diaDelete, setDiaDelete] = useState<boolean>(false);
    // const isUseCoachingSkills = useSelector(selectIsUseCoachingSkills);

    const menu = useRef<Menu | any>();
    const items: any = [];
    items.push(
        {
            label: 'Edit',
            icon: 'pi pi-pencil',
            command: () => {
                handleEdit();
            },
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
                if (strengthList[first]?.author_employee_number === authorId) {
                    setDiaDelete(true);
                } else {
                    toast.warning('Only author can delete.');
                }
            },
        }
    );

    const popupMenuClickHandler = (e: any) => {
        e.preventDefault();
        menu.current?.toggle(e);
    };

    useEffect(() => {
        setIsResponse(strengthList[first]?.response_description?.trim()?.length > 0);
        if (strengthList.length - 1 < first)
            setFirst(strengthList.length - 1 > 0 ? strengthList.length - 1 : 0);
    }, [strengthList, first]);

    const onPageChange = (event: any) => {
        if (strengthList?.length < first || strengthList?.length === undefined) setFirst(0);
        else setFirst(event.first);
    };

    const handleEdit = () => {
        if (strengthList[first]?.author_employee_number === authorId) {
            OnViewState('edit');
            OnEditStrength(strengthList[first]);
        } else {
            toast.warning('Only author can edit.');
        }
    };

    const handleDelete = () => {
        const payload = {
            coachingId: strengthList[first]?.coaching_strength_id,
            coachingItem: 'strength',
        };
        DeleteCoaching(payload)
        .unwrap()
        .then((res: any) => {
            if (res?.data) {
                toast.success('Strength Deleted successfully');
                setDiaDelete(false);
            } else {
                toast.error('Error Deleting strength');
            }
        })
        .catch(() => {
            toast.error('Error Deleting strength');
        });
    };

    const renderStrength = (strength: StrengthList) => {
        const StrengthId = strength?.coaching_strength_id;
        const coreValueId = strength?.core_value_id;
        const strengthDate = new Date(strength?.strength_date);
        const date = getMonthName(strengthDate.getMonth() + 1) + ' - ' + strengthDate.getFullYear();

        return (
            <div className="coachingStrengths mt-2">
                <h4>{strength?.strength_title}</h4>
                <div className="d-flex justify-content-start mb-2">
                    <div className="col-3 me-3">
                        <h6>Date</h6>
                        <div>{changeDateFormate(datetimeToDate(date))}</div>
                    </div>
                    <div className="col-3 me-3">
                            <h6>Value</h6>
                            <div>{strength?.core_value_name}</div>
                        </div>
                    {/* {!isUseCoachingSkills ? (
                        <div className="col-3 me-3">
                            <h6>Value</h6>
                            <div>{strength?.core_value_name}</div>
                        </div>
                    ) : (
                        <>
                            <div className="col-3 me-3">
                                <h6>Skill</h6>
                                <div>{strength?.coaching_skill_name}</div>
                            </div>
                            <div className="col-3 me-3">
                                <h6>Behavior</h6>
                                <div>{strength?.coaching_behavior_name}</div>
                            </div>
                        </>
                    )} 
                    <div className={isUseCoachingSkills ? 'col-2' : 'col-5'}>*/}
                    <div className='col-5'>
                        <Button
                            type="button"
                            icon="pi pi-ellipsis-v"
                            className="float-end"
                            style={{
                                background: 'transparent',
                                border: '#CECECD 0px solid',
                                color: '#3F5765',
                            }}
                            onClick={(e: any) => {
                                popupMenuClickHandler(e);
                            }}
                        />
                        {/* <Button
                        className="editBtnIcon p-button-outlined border-0"
                        onClick={handleEdit}
                    /> */}
                    </div>
                </div>
                <h6>Description</h6>
                <InputTextarea
                    value={strength?.strength_description}
                    readOnly
                    className="borderRadius8 w-100"
                    autoResize={false}
                />
                <div className="d-flex justify-content-between mt-3 mb-3">
                    <h6>Author : {strength?.author_employee_name} </h6>
                    <div className="d-flex justify-content-end gap-2">
                        {!isResponse && (
                            <Button
                                label="Add comment"
                                onClick={() => {
                                    setCommentView(true);
                                }}
                                className="btn-secondary me-2"
                            />
                        )}
                        <CoachingShoutOut
                            receiverId={recieverId}
                            receiverName={receiverName}
                            visible={shoutoutVisible}
                            setVisible={() => setTodoShoutOutVisible(!shoutoutVisible)}
                            coachingEntityTypeId={3}
                            coachingEntityId={StrengthId}
                            coreValueId={coreValueId}
                        />
                    </div>
                </div>
                <div className="mt-3">
                    {(isResponse || commentView) && (
                        <StrengthCommentCard
                            onCancel={() => {
                                setCommentView(false);
                            }}
                            setIsResponse={setIsResponse}
                            listItem={strength}
                            isResponse={isResponse}
                            recieverId={recieverId}
                            receiverName={receiverName}
                            strengthId={StrengthId}
                        />
                    )}
                </div>
            </div>
        );
    };

    const noMatch = () => {
        return <div className="noMatch">There are no Stregths to display.</div>;
    };

    const displayGuidance = () => userRole !== 'associate';
    const handleGuidance = () => {
        setIsGuidanceVisible(!isGuidanceVisible);
    };

    return (
        <>
            <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
            <Dialog
                header={
                    <Header
                        authorId={authorId}
                        OnViewState={OnViewState}
                        setStrengthList={setStrengthList}
                        receiverId={recieverId}
                        month={month}
                        year={year}
                        via={via}
                        coachingEntityId={coachingEntityId}
                    />
                }
                footer={
                    <div className="row align-items-start">
                        {displayGuidance() && (
                            <div className="col-2 p-2 text-center">
                                <Button
                                    icon="pi pi-question-circle"
                                    className="btn-primary"
                                    label="Guidelines"
                                    onClick={() => handleGuidance()}
                                />
                            </div>
                        )}
                        {strengthList.length > 0 && (
                            <div className="col-10">
                                <Paginator
                                    first={first}
                                    rows={1}
                                    totalRecords={strengthList.length}
                                    onPageChange={onPageChange}
                                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                />
                            </div>
                        )}
                    </div>
                }
                visible={displayModal}
                onHide={() => {
                    OnDisplayModal(false);
                    OnViewState('read');
                }}
                className="card shadow bg-body rounded mt-4 border-0 p-0 w-65"
                modal
                draggable={false}
                resizable={false}
                style={{
                    width: '66vw',
                    height: '90vh',
                    zIndex: '9998',
                }}
                position="top-right"
            >
                {strengthList.length > 0 ? (
                    <div className="p-10">{renderStrength(strengthList[first] as StrengthList)}</div>
                ) : (
                    noMatch()
                )}
            </Dialog>
            {diaDelete && (
                <DeleteCoachingDialog
                    diaDelete={diaDelete}
                    setDiaDelete={setDiaDelete}
                    handleDelete={handleDelete}
                />
            )}
            {isGuidanceVisible && (
                <Guidance from="Read" isGuidanceVisible={isGuidanceVisible} onHide={handleGuidance} />
            )}
        </>
    );
};
export default ReadStrengths;
